/* tslint:disable */

declare var Object: any;
export interface TtadovtrequestInterface {
  "requestno": string;
  "requestedby"?: string;
  "ovttype"?: string;
  "leavetypecode"?: string;
  "requestdatefrom"?: Date;
  "requestdateto"?: Date;
  "remark"?: string;
  "companyId": number;
  "approvalstatus"?: number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "reqtype"?: string;
  "ovtReason"?: string;
  "uploadFilename"?: string;
  tcltrequests?: any;
  ttadattovtdetails?: any[];
  ttadovtrequestdetails?: any[];
  ttadattovtcanceldetails?: any[];
}

export class Ttadovtrequest implements TtadovtrequestInterface {
  "requestno": string;
  "requestedby": string;
  "ovttype": string;
  "leavetypecode": string;
  "requestdatefrom": Date;
  "requestdateto": Date;
  "remark": string;
  "companyId": number;
  "approvalstatus": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "reqtype": string;
  "ovtReason": string;
  "uploadFilename": string;
  tcltrequests: any;
  ttadattovtdetails: any[];
  ttadovtrequestdetails: any[];
  ttadattovtcanceldetails: any[];
  constructor(data?: TtadovtrequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadovtrequest`.
   */
  public static getModelName() {
    return "Ttadovtrequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadovtrequest for dynamic purposes.
  **/
  public static factory(data: TtadovtrequestInterface): Ttadovtrequest{
    return new Ttadovtrequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadovtrequest',
      plural: 'Ttadovtrequests',
      path: 'Ttadovtrequests',
      properties: {
        "requestno": {
          name: 'requestno',
          type: 'string'
        },
        "requestedby": {
          name: 'requestedby',
          type: 'string'
        },
        "ovttype": {
          name: 'ovttype',
          type: 'string'
        },
        "leavetypecode": {
          name: 'leavetypecode',
          type: 'string'
        },
        "requestdatefrom": {
          name: 'requestdatefrom',
          type: 'Date'
        },
        "requestdateto": {
          name: 'requestdateto',
          type: 'Date'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "approvalstatus": {
          name: 'approvalstatus',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "reqtype": {
          name: 'reqtype',
          type: 'string'
        },
        "ovtReason": {
          name: 'ovtReason',
          type: 'string'
        },
        "uploadFilename": {
          name: 'uploadFilename',
          type: 'string'
        },
      },
      relations: {
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        ttadattovtdetails: {
          name: 'ttadattovtdetails',
          type: 'any[]',
          model: ''
        },
        ttadovtrequestdetails: {
          name: 'ttadovtrequestdetails',
          type: 'any[]',
          model: ''
        },
        ttadattovtcanceldetails: {
          name: 'ttadattovtcanceldetails',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadovtrequest.ts